import { render, staticRenderFns } from "./CannyFeedback.vue?vue&type=template&id=7b1e5f69&"
import script from "./CannyFeedback.vue?vue&type=script&lang=js&"
export * from "./CannyFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports